import { forwardRef } from 'react';
import Button from '../Button';
import { TabProps } from './tabTypes';

type Ref = HTMLButtonElement;

const Tab = forwardRef<Ref, TabProps>(({ children, active, onClick }, ref) => (
    <Button
        ref={ref}
        className={`tab ${active ? 'active' : ''}`}
        tabIndex={active ? -1 : 0}
        onClick={onClick}
    >
        {children}
    </Button>
));

export default Tab;
